
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_64tge_1scxg_5",
  "secondary-header": "awsui_secondary-header_64tge_1scxg_9",
  "notifications": "awsui_notifications_64tge_1scxg_13",
  "breadcrumbs": "awsui_breadcrumbs_64tge_1scxg_17"
};
  